import PropTypes from 'prop-types';
import React, {useEffect, useMemo, useState} from 'react';
import {useTranslation} from 'react-i18next';
import Icon from "../../Components/Icon/index.jsx";

import Page from '../../Components/Page';
import Button from '../../Components/Utils/Button';
import ReactTable from '../../Components/Utils/ReactTable';
import {dateFormatting} from '../../Utils';

import {ORGANIZATION_TYPE} from "../../Constants.js";
import {useSelector} from 'react-redux';
import {useRequestAllProvidersQuery} from '../../redux/api/providers';
import {selectAuthData} from '../../redux/selectors/auth';
import ProviderModal from '../../Components/Modals/ProviderModal';
import {prepareData} from '../../Utils/dataFunctions.js';
import { activeProvidersFilter} from '../../QueryFilters/queries.js';
import {useRequestOrganizationsTypeQuery} from '../../redux/api/organizations.js';

import './style.scss';

function Providers() {
    const {user: {id: userId = ''} = {}} = useSelector(selectAuthData);
    const [page, setPage] = useState(0);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const cacheParams = {page, itemsPerPage, userId};
    const {
        data: {list: providers = [], pageCount} = {},
        isFetching: isProviderFetching,
        isError: isProviderError,
        error: providerError,
        refetch
    } = useRequestAllProvidersQuery(JSON.stringify(activeProvidersFilter));

    const [providersData, setProvidersData] = useState(providers);
    const [searchTerm, setSearchTerm] = useState('');

    useEffect(() => {
        const updatedData = prepareData(providers);
        setProvidersData(updatedData);
    }, [providers]);

    const organizationTypes = useRequestOrganizationsTypeQuery({});
    const [proivderId, setProviderId] = useState('');

    useEffect(() => {
        let providerTypeId = organizationTypes.data?.find(type => type.name === ORGANIZATION_TYPE.PROVIDER)?.id;
        setProviderId(providerTypeId)

    }, [organizationTypes.data]);

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [modalData, setModalData] = useState({});
    const toggleAddModal = () => {
        setIsModalOpen(!isModalOpen);
        setModalData({});
    };
    const openEditModal = (modalData = {}) => {
        setModalData(modalData);
        setIsModalOpen(true);
    };
    const {t} = useTranslation();

    const columns = useMemo(() => {
        return [
            {
                accessor: '_id',
                disableSortBy: true
            },
            {
                Header: t('name'),
                accessor: 'name'
            },
            {
                Header: t('created_at'),
                accessor: 'createdAt',
                defaultSortBy: true,
                Cell: ({cell}) => dateFormatting(cell.row.values.createdAt)
            },
            {
                Header: t('contact_email'),
                accessor: 'organizationProperties',
                Cell: ({cell}) => {
                    return cell.row.values.organizationProperties?.contact_email;
                }
            },
            {
                Header: t('contact_phone'),
                Cell: ({cell}) => {
                    return cell.row.values.organizationProperties?.contact_phone;
                }
            },

            {
                Header: t('actions'),
                accessor: 'actions',
                className: 'table-action-cell',
                Cell: ({cell}) => (
                    <Button
                        className='button button__alfa'
                        onClick={() => {
                            openEditModal(cell.row.original);
                        }}>
                        {t('edit')}
                    </Button>
                )
            }
        ];
    }, [providersData, t]);

    const headerItems = (
        <>
            <div className={'providers__search-bar'}>
                <Icon iconName={'search'} iconClass={'providers__search_icon'} />
                <input
                    className='providers__search_input'
                    value={searchTerm}
                    placeholder={t('search')}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    style={{marginRight: '10px'}} // added inline style for spacing
                />
            </div>
            <Button className='button button__alfa' onClick={toggleAddModal}>
                {t('add_provider')}
            </Button>
        </>
    );

    const filteredData = useMemo(() => {
        return providersData.filter(item => {
            const searchableString = `${item.name} ${item.organizationProperties?.contact_email} ${item.organizationProperties?.contact_phone}`.toLowerCase();
            return searchableString.includes(searchTerm.toLowerCase());
        });
    }, [providersData, searchTerm]);

    return (
        <Page title={t('providers')} customHeaderItems={headerItems}>
            {isModalOpen && (
                <ProviderModal
                    initialScratchFilter='provider_id'
                    modalData={modalData}
                    toggleModal={toggleAddModal}
                    providerTypeId={proivderId}
                    refetch={refetch}
                />
            )}
            <ReactTable
                loading={isProviderFetching}
                hiddenColumns={['id']}
                data={filteredData}
                columns={columns}
                setControlledPageSize={setItemsPerPage}
                setControlledPageIndex={setPage}
                controlledPageCount={pageCount}
            />
            {isProviderError && <p>{providerError}</p>}
        </Page>
    );
}

export default Providers;

Providers.propTypes = {
    cell: PropTypes.any
};